const sajdaData = {
  "7:206": true,
  "13:15": true,
  "16:50": true,
  "17:109": true,
  "19:58": true,
  "22:18": true,
  "22:77": true, // Shafi'i and Hanbali schools
  "25:60": true,
  "27:26": true,
  "32:15": true,
  "38:24": true, // Hanafi school
  "41:38": true,
  "53:62": true,
  "84:21": true,
  "96:19": true,
};

export default sajdaData;